import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const PadRedirectComponentActions = createActionGroup({
  source: 'Pad Redirect Component',
  events: {
    'Pad Redirect Landed': emptyProps(),
    'Pad Redirect Url Generated': props<{ redirectUrl: string }>(),
  },
});
